/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductCategroyResponseDto>;
export function request(
  body: defs.basics.ProductCategroyRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productCategroy/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
